import React from "react";
import { Container, Table } from "react-bootstrap";

const IndikatorenFuerDQ_m = () => {
  return (
    <Container className="mt-4">
      <h2 className="section-title">Datenqualität</h2>
      <div className="section-title-underline"></div>

      <div className="aktuelles-text" style={{ marginTop: "1rem" }}>
        <p>
          Die Erfüllung diagnostischer Kriterien ist ein wichtiger Bestandteil
          zur Beurteilung der Datenqualität. Der HV–Anteil (histologisch
          verifizierte Diagnosen) ist der prozentuale Anteil der
          Erkrankungsfälle mit einer histologischen oder zytologischen Sicherung
          in Bezug auf alle Diagnosen und gibt Hinweise darauf, wie valide die
          Diagnosen sind. Hier wird ein Wert von 95% angestrebt.
        </p>

        <p>
          Ein hoher Anteil von Erkrankungsfällen mit einem unbekannten oder
          ungenau bezeichneten Primärtumor (PSU-Anteil, primary site unknown)
          zeugt von minderer Qualität. Die Zahl dieser Fälle sollte 5% nicht
          überschreiten.
        </p>

        <p>
          Diese und weitere Qualitätsmerkmale für die Datenerfassung sind in der
          Tabelle mit zugehörigem Sollwert aufgeführt. Alle Kriterien zur
          Vollständigkeit sind innerhalb des Einzugsgebietes des KKR LSA
          erfüllt.
        </p>
      </div>

      <h5 className="mt-4 mb-3">
        Indikatoren für die Datenqualität, dargestellt für die Gesamtheit der
        Krebserkrankungen (ohne C44) mit Diagnosejahre 2020–2021 zum Zeitpunkt
        der Datenextraktion
      </h5>

      <div style={{ overflowX: "auto" }}>
        <Table striped bordered hover responsive size="sm">
          <thead>
            <tr>
              <th>Bezeichnung</th>
              <th>Sollwert</th>
              <th>Istwert</th>
            </tr>
          </thead>
          <tbody>
            {[
              ["HV-Anteil (histologisch verifizierte Diagnosen)", "≥ 95%", "96,9%"],
              ["Unbekannter Primärtumor*", "≤ 5%", "1,7%"],
              ["Vollständigkeit Stammdaten der Erkrankten", "≥ 95%", "100%"],
              ["Vollständigkeit Tumordiagnose (ICD-10)", "≥ 95%", "98,2%"],
              ["Vollständigkeit Hauptlokalisation (ICD-O-3)", "≥ 95%", "98,2%"],
              ["Vollständigkeit Diagnosedatum (mind. monatsgenau)", "≥ 95%", "97,6%"],
              ["Vollständigkeit Tumorhistologie", "≥ 95%", "97,3%"],
              ["Vollständigkeit Residualklassifikation", "≥ 95%", "97,5%"],
              ["Vollständigkeit TNM-Klassifikation", "≥ 80%", "85,2%"],
              ["Vollständigkeit Histologisches Grading", "≥ 80%", "83,1%"],
            ].map(([desc, soll, ist], i) => (
              <tr key={i}>
                <td>{desc}</td>
                <td>{soll}</td>
                <td>{ist}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <p
        style={{
          fontSize: "0.9rem",
          fontStyle: "italic",
          marginTop: "0.5rem",
        }}
      >
        * ICD-O-3: (C26.0, C26.9, C39.0, C39.9, C76, C80.9)
      </p>
    </Container>
  );
};

export default IndikatorenFuerDQ_m;

